export const INGREDIENTS_SCREEN_TARGET = 'ingredientsScreen';
